module.exports = __webpack_public_path__ + "static/img/img-4.a29ea4f1.png";